export default __webpack_public_path__ + "static/media/Poppins-Thin.a49f72a2.svg";